
import { OrderInfo } from '@/entities/OrderInfo';
import DB from '@tencent/db';
import { getOrders } from './order';

DB.mergeOption({
  type: 'POST',
  bknEnable: false, // 全局使用bkn
  contentType: 'application/json',
  getRetCode: (data: any) => {
    const retCode = data?.code;
    console.log(data, data.header, retCode, retCode === 0);
    if (retCode === 0) {
      return 0;
    }
    return retCode;
  },
});
const db = new DB();

const mockList: any[] = [];
for (let index = 0; index < 10; index++) {
  mockList.push({
    outTradeNo: '271056289',
    amt: 29900,
    productId: '271056289',
    productName: '中华历史故事-含书包礼盒',
    orderTime: '1679466550',
    payTime: '1679466550',
    orderState: '8',
  });
}

export interface RecordList {
  orders: OrderInfo[];
  total: number;
  afterSalesUrl?: string; // 售后url
}


// 获取列表
export async function getList(params: { start: number; size: number; }): Promise<any> {
  console.log('🚀 ~ file: index.ts:34 ~ getList ~ params:', params);
  const { start = 0 } = params;
  return new Promise((resolve, reject) => {
    getOrders(start, (res) => {
      console.log('🚀 ~ file: index.ts:45 ~ list ~ res:', res);
      resolve(res);
    }, (err) => {
      console.log('🚀 ~ file: index.ts:47 ~ list ~ err:', err);
      reject(err);
    });
  });
};

export async function request(url: string, params: any, type = 'GET') {
  return db.ajax({
    url,
    type,
    data: params,
  }).then((data: any) => {
    console.log('🚀 ~ file: index.ts:38 ~ test ~ data:', data);
  }).catch((error: any) => {
    console.log('🚀 ~ file: index.ts:40 ~ test ~ error:', error);
  });
}
